export default () => ({
  active: "login",
  activeMenu: null,
  handPickedCount: "",
  favoritesCount: "",
  ordersCount: "",

  init() {
    this.activeMenu = window.location.search;
    this.setFavoritesCount();
    this.setOrdersCount();
  },

  setFavoritesCount() {
    CF.customerReady(
      function () {
        let customerFavorites = CF.customer.get("favorites_list") || [];
        let cfLength = customerFavorites.length;
        if (customerFavorites.length > 0) {
          this.favoritesCount =
            cfLength >= 1 && cfLength <= 9
              ? "0" + cfLength
              : cfLength.toString();
        } else {
          this.favoritesCount = "";
        }
      }.bind(this)
    );
  },

  setOrdersCount() {
    const url = `${shopUrl}/apps/jl-api/frontend/voyado/transactions`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        let oLength = data.count;
        if (oLength > 0) {
          this.ordersCount =
            oLength >= 1 && oLength <= 9 ? "0" + oLength : oLength.toString();
        } else {
          this.ordersCount = "";
        }
      });
  },
});
